module.exports = __webpack_public_path__ + "static/media/file.cdb1b475.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/file.svg
// module id = 597
// module chunks = 0